import { Link, useLocation } from "react-router-dom";
import { Compass } from "lucide-react";

const NAV = [
  { href: "/#comment", l: "Comment ça marche", id: "nav-how-link" },
  { href: "/#exemples", l: "Exemples", id: "nav-examples-link" },
  { href: "/#faq", l: "FAQ", id: "nav-faq-link" },
];

export const Header = () => {
  const { pathname } = useLocation();
  const dark = pathname === "/";
  return (
    <header
      data-testid="site-header"
      className={`${dark ? "absolute text-white" : "sticky bg-[#0B131E]/95 backdrop-blur-md text-white"} top-0 inset-x-0 z-40`}
    >
      {dark ? (
        <a href="#premium" data-testid="launch-banner" className="block bg-amber-500 text-[#0B131E] text-center text-sm font-semibold py-2 px-4 hover:bg-amber-400 transition-colors">
          <span className="mr-2 inline-block rounded-full bg-[#0B131E] text-amber-400 text-[10px] uppercase tracking-widest px-2 py-0.5 align-middle">Nouveau</span>
          Votre escapade complète pour 4,90 € <span className="hidden sm:inline font-normal">· paiement unique, sans abonnement</span> →
        </a>
      ) : null}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="header-logo-link" className="flex items-center gap-2 group">
          <Compass className="w-5 h-5 text-amber-500 transition-transform duration-500 group-hover:rotate-180" />
          <span className="font-serif text-xl font-semibold tracking-tight">Wanderlust</span>
        </Link>
        <nav className="flex items-center gap-6 text-sm text-gray-300">
          {NAV.map((n) => (
            <a key={n.id} href={n.href} data-testid={n.id} className="hidden md:inline hover:text-white transition-colors">{n.l}</a>
          ))}
          <a href="/#recherche" data-testid="nav-search-link" className="px-4 py-2 rounded-full bg-amber-500 text-[#0B131E] font-semibold hover:bg-amber-400 transition-colors">
            Trouver mon escapade
          </a>
        </nav>
      </div>
    </header>
  );
};
